import { getRecord, getDetail, getFormCategory, setDeal, delRecords } from '@/services/smart'
import i18n from '@/lib/language'
const store = {
  namespaced: true,
  state: {
    loading: false,
    formColumns: [
      // {
      //   title: '状态',
      //   dataIndex: 'status',
      //   key: 'status',
      //   scopedSlots: { customRender: 'status' }
      // },
      {
        title: i18n.t('message["605"]'),
        dataIndex: 'contact',
        key: 'contact',
        scopedSlots: { customRender: 'contact' },
        width: 132
      }, {
        title: i18n.t('message["582"]'),
        dataIndex: 'from_url',
        key: 'from_url',
        scopedSlots: { customRender: 'url' },
        width: 256
      }, {
        title: i18n.t('message["580"]') + 'IP',
        dataIndex: 'from_ip',
        key: 'from_ip',
        scopedSlots: { customRender: 'ip' }
      }, {
        title: i18n.t('message["1157"]'),
        key: 'form_name',
        dataIndex: 'form_name',
        scopedSlots: { customRender: 'form_name' },
        width: 132
      }, {
        title: i18n.t('message["549"]'),
        key: 'username',
        dataIndex: 'username',
        scopedSlots: { customRender: 'username' },
        width: 156
      }, {
        title: i18n.t('message["1170"]'),
        sorter: true,
        key: 'addtime',
        dataIndex: 'addtime',
        scopedSlots: { customRender: 'addtime' }
      }],
    statusTable: Object.freeze({
      '-1': i18n.t('message["138"]'),
      '1': i18n.t('message["1452"]'),
      '2': i18n.t('message["1452"]'),
      '3': i18n.t('message["62"]'),
      '-2': i18n.t('message["62"]'),
      '-3': i18n.t('message["62"]')
    }),
    recordList: [],
    totalCount: 0,
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 50],
      pageSizesType: { 10: 1, 20: 2, 30: 3, 50: 4 },
      total: 0
    },
    // 状态选择器数据
    statusSelect: [
      { value: 0, name: i18n.t('message["138"]') },
      { value: 1, name: i18n.t('message["1469"]') },
      { value: 2, name: i18n.t('message["65"]') }
    ],
    // 记录详情
    listDetail: {},
    // 表单名字类别
    formCategory: [],
    // 拦截记录的数量
    interceptCount: 0,
    // 表单管理跳转到提交记录携带的参数
    subQuery: {},
    // 是否有录入权限
    isInqueryAdd: true,
    // 提交记录查询的参数
    queryParams: {},
    detailData: {}
  },
  mutations: {
    SET_RECORD_LIST (state, list) {
      state.recordList = list
    },
    SET_TOTAL_COUNT (state, total) {
      state.totalCount = total
    },
    SET_DETAIL_DATA (state, data) {
      state.detailData = data
    },
    SET_PAGINATION (state, params) {
      const { key, value } = params
      state.pagination = Object.assign(state.pagination, { [key]: value })
    },
    SET_LIST_DETAIL (state, detail) {
      const { formid, formtype, pipei, status, reason, addtime } = detail
      state.listDetail = Object.assign({}, { formid }, { from_url: detail['from_url'] }, { from_ip: detail['from_ip'] }, { addtime }, { formtype }, { data: pipei.all }, { status }, { reason })
    },
    SET_LOADING (state, load) {
      state.loading = load
    },
    SET_FORM_CATEGORY (state, list) {
      state.formCategory = list
    },
    SET_INTERCEPT_COUNT (state, count) {
      state.interceptCount = count
    },
    SET_SUB_QUERY (state, query) {
      state.subQuery = Object.assign({}, query)
    },
    SET_INQUERY_ADD (state, type) {
      state.isInqueryAdd = type
    },
    SET_QUERY_PARAMS (state, params) {
      state.queryParams = Object.assign({}, params)
    }
  },
  actions: {
    // 获取提交记录数据列表
    async fetchDataList ({ commit }, params) {
      commit('SET_LOADING', true)
      const chain = await getRecord()
        .params({ scope: 1, ...params })
        .onSuccess((res, all) => {
          const { permissions } = all
          const { count, list, intercept } = res
          commit('SET_TOTAL_COUNT', count)
          commit('SET_RECORD_LIST', list)
          commit('SET_INTERCEPT_COUNT', intercept)
          commit('SET_PAGINATION', { key: 'total', value: Number(count) })
          commit('SET_INQUERY_ADD', permissions['inquiry-add'])
        })
        .onNetComplete(() => {
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    // 获取查询表单分类
    async fetchFormCategory ({ commit }) {
      const chain = await getFormCategory()
        .onSuccess(res => {
          commit('SET_FORM_CATEGORY', res)
        })
        .fetch()
      return chain
    },
    // 获取信息详情
    async fetchRecordDetail ({ commit }, params) {
      const chain = await getDetail()
        .params(params)
        .onSuccess((res) => {
          // console.log(res)
          commit('SET_LIST_DETAIL', res)
          commit('SET_DETAIL_DATA', res)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 标记为不处理
    async setInfoDeal ({ commit }, params) {
      const chain = await setDeal()
        .params(params)
      return chain
    },
    // 删除提交记录
    async delRecords ({ commit, dispatch }, params) {
      const chain = await delRecords()
        .params(params)
        .onSuccess(res => {
          // commit('SET_FORM_CATEGORY', res)
          // dispatch('fetchDataList')
        })
        // .fetch()
      return chain
    }
  }
}

export default store
